var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTresEstrellas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 131.339,
    height: 129.45,
    viewBox: "0 0 131.339 129.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_108643",
    x: 0,
    y: 0,
    width: 131.339,
    height: 129.45,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23171",
    "data-name": "Grupo 23171",
    transform: "translate(-494 -161.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 494, 162)",
    filter: "url(#Trazado_108643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108643-2",
    "data-name": "Trazado 108643",
    d: "M111.8,37.166l-2.345-3.331,1.2-3.889A8.439,8.439,0,0,0,100.1,19.395l-3.886,1.2-3.328-2.343a8.423,8.423,0,0,0-5.649-1.484,5.459,5.459,0,0,0-.644.068,5.078,5.078,0,0,0-.583.138,8.358,8.358,0,0,0-6.376,7.456,5.767,5.767,0,0,0-.041.6l-.059,4.07-3.257,2.442a8.428,8.428,0,0,0-3.367,7.169c.008.167.043.328.061.493a37.676,37.676,0,0,0-3.659-1.505,8.389,8.389,0,0,0,3.075-7.766l-.577-4.03,2.839-2.923A8.437,8.437,0,0,0,70.038,8.789l-4.012-.7-1.9-3.6a8.44,8.44,0,0,0-14.92,0l-1.9,3.6-4.007.695a8.436,8.436,0,0,0-4.61,14.186L41.522,25.9l-.578,4.03a8.389,8.389,0,0,0,3.086,7.78,37.5,37.5,0,0,0-3.638,1.508,8.45,8.45,0,0,0-3.328-7.683l-3.256-2.44-.059-4.072a8.438,8.438,0,0,0-13.293-6.773l-3.331,2.345-3.9-1.2A8.44,8.44,0,0,0,2.805,24.6l-.1.306c-.007.022-.013.044-.021.066l-.183.6v.149c-.037.156-.07.315-.1.488a8.518,8.518,0,0,0,.281,3.737l1.2,3.887L1.541,37.162A8.5,8.5,0,0,0,.7,38.652a6.11,6.11,0,0,0-.288.827,6.014,6.014,0,0,0-.222.754A8.438,8.438,0,0,0,8.316,50.456l4.069.059,2.44,3.255a8.357,8.357,0,0,0,7.66,3.322A37.937,37.937,0,1,0,94.619,73.5c0-.656-.017-1.309-.05-1.939-.01-.215-.027-.428-.045-.641l-.036-.483c-.019-.273-.037-.546-.065-.813a38,38,0,0,0-3.5-12.511c.276.027.552.047.83.047a8.466,8.466,0,0,0,6.758-3.382l2.441-3.257,4.071-.059A8.439,8.439,0,0,0,111.8,37.166M24.633,51.724h0ZM51.186,34.977Z",
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23139",
    "data-name": "Grupo 23139",
    transform: "translate(503 168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108644",
    "data-name": "Trazado 108644",
    d: "M61.2,7.285l-2.7,5.109a.663.663,0,0,1-.476.346l-5.694.988a4.29,4.29,0,0,0-2.345,7.214l4.026,4.146a.663.663,0,0,1,.183.56l-.82,5.722a4.291,4.291,0,0,0,6.136,4.46L64.7,33.282a.677.677,0,0,1,.59,0L70.48,35.83a4.29,4.29,0,0,0,6.136-4.46l-.82-5.722a.663.663,0,0,1,.183-.56L80,20.942a4.29,4.29,0,0,0-2.345-7.214l-5.7-.988a.663.663,0,0,1-.476-.346l-2.7-5.109a4.292,4.292,0,0,0-7.588,0",
    transform: "translate(-8.33 -0.854)",
    fill: "#ee2b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108645",
    "data-name": "Trazado 108645",
    d: "M117.193,27.653l-5.518,1.7a.668.668,0,0,1-.58-.09l-4.727-3.329a4.29,4.29,0,0,0-6.761,3.445l-.083,5.779a.665.665,0,0,1-.268.523l-4.624,3.466a4.291,4.291,0,0,0,1.187,7.494l5.473,1.866a.668.668,0,0,1,.415.415l1.867,5.473a4.288,4.288,0,0,0,7.492,1.187l3.466-4.624a.663.663,0,0,1,.525-.268l5.777-.083a4.291,4.291,0,0,0,3.445-6.761l-3.327-4.727a.669.669,0,0,1-.092-.58l1.7-5.523a4.292,4.292,0,0,0-5.364-5.366Z",
    transform: "translate(-15.868 -4.296)",
    fill: "#ee2b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108646",
    "data-name": "Trazado 108646",
    d: "M7.5,33.02l1.7,5.52a.669.669,0,0,1-.092.58L5.784,43.847A4.29,4.29,0,0,0,9.23,50.606l5.777.083a.663.663,0,0,1,.525.268L19,55.58a4.288,4.288,0,0,0,7.492-1.187l1.867-5.473a.668.668,0,0,1,.415-.415l5.473-1.866a4.291,4.291,0,0,0,1.187-7.494l-4.624-3.464a.669.669,0,0,1-.268-.525l-.083-5.779A4.291,4.291,0,0,0,23.7,25.934L18.97,29.261a.663.663,0,0,1-.58.092l-5.527-1.7A4.293,4.293,0,0,0,7.5,33.019Z",
    transform: "translate(-0.854 -4.295)",
    fill: "#ee2b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108647",
    "data-name": "Trazado 108647",
    d: "M61.377,47.868a33.8,33.8,0,1,1-33.8,33.8,33.8,33.8,0,0,1,33.8-33.8",
    transform: "translate(-4.709 -8.175)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108648",
    "data-name": "Trazado 108648",
    d: "M77.563,92.237l-26.038.047a5.39,5.39,0,0,0-4.97,7.435,19.451,19.451,0,0,0,36.036.02,5.434,5.434,0,0,0-5.026-7.505Z",
    transform: "translate(-7.882 -15.751)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108649",
    "data-name": "Trazado 108649",
    d: "M48.771,79.158a2.789,2.789,0,0,1,1.358-1.736,5.135,5.135,0,0,1,1.289-.574,5.291,5.291,0,0,1,2.065-.276,5.258,5.258,0,0,1,1.728.172,5.711,5.711,0,0,1,1.123.382,3.014,3.014,0,0,1,1.859,2.032.912.912,0,0,0,1.824,0,5.127,5.127,0,0,0-1.981-4.478,7.24,7.24,0,0,0-3.068-1.552,7.122,7.122,0,0,0-1.493-.177,7.51,7.51,0,0,0-1.97.3,7.027,7.027,0,0,0-2.6,1.41,5.124,5.124,0,0,0-1.969,4.5.912.912,0,0,0,1.824,0Z",
    transform: "translate(-8.013 -12.458)",
    fill: "#354e5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108650",
    "data-name": "Trazado 108650",
    d: "M75.776,79.158a2.789,2.789,0,0,1,1.36-1.736,5.148,5.148,0,0,1,1.294-.575,8.244,8.244,0,0,1,3.79-.1,5.656,5.656,0,0,1,1.123.382A3.012,3.012,0,0,1,85.2,79.16a.912.912,0,0,0,1.824,0,5.125,5.125,0,0,0-1.981-4.478,7.24,7.24,0,0,0-3.068-1.552,7.122,7.122,0,0,0-1.493-.177,7.51,7.51,0,0,0-1.97.3,7.027,7.027,0,0,0-2.6,1.41,5.128,5.128,0,0,0-1.967,4.5.912.912,0,0,0,1.824,0",
    transform: "translate(-12.626 -12.459)",
    fill: "#354e5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108651",
    "data-name": "Trazado 108651",
    d: "M54.761,108.059a1.81,1.81,0,0,0,.7,2.193,19.413,19.413,0,0,0,21.081.006,1.81,1.81,0,0,0,.7-2.195c-1.61-4.02-6.009-6.99-11.238-6.99s-9.624,2.969-11.236,6.987Z",
    transform: "translate(-9.33 -17.261)",
    fill: "#e40c5b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108652",
    "data-name": "Trazado 108652",
    d: "M61.2,7.285l-2.7,5.109a.663.663,0,0,1-.476.346l-5.693.988a4.29,4.29,0,0,0-2.345,7.214l4.026,4.146a.663.663,0,0,1,.183.56l-.82,5.722a4.291,4.291,0,0,0,6.136,4.46L64.7,33.282a.677.677,0,0,1,.59,0L70.48,35.83a4.29,4.29,0,0,0,6.136-4.46l-.82-5.722a.663.663,0,0,1,.183-.56l4.026-4.146a4.29,4.29,0,0,0-2.345-7.214l-5.7-.988a.663.663,0,0,1-.476-.346l-2.7-5.109a4.292,4.292,0,0,0-7.588,0m3.2,1.692a.668.668,0,0,1,1.181,0l2.7,5.112a4.282,4.282,0,0,0,3.059,2.224l5.693.988a.663.663,0,0,1,.366,1.123L73.381,22.57a4.287,4.287,0,0,0-1.168,3.6l.818,5.722a.668.668,0,0,1-.956.69l-5.187-2.546a4.3,4.3,0,0,0-3.781,0l-5.185,2.546a.668.668,0,0,1-.956-.7l.818-5.722a4.287,4.287,0,0,0-1.168-3.6l-4.026-4.146a.663.663,0,0,1,.366-1.123l5.693-.988a4.282,4.282,0,0,0,3.059-2.224Z",
    transform: "translate(-8.33 -0.854)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108653",
    "data-name": "Trazado 108653",
    d: "M117.193,27.652l-5.518,1.7a.671.671,0,0,1-.58-.09l-4.727-3.329a4.29,4.29,0,0,0-6.761,3.445l-.083,5.779a.665.665,0,0,1-.268.523L94.633,39.15a4.291,4.291,0,0,0,1.187,7.494l5.473,1.866a.668.668,0,0,1,.415.415l1.867,5.473a4.288,4.288,0,0,0,7.492,1.187l3.466-4.624a.663.663,0,0,1,.525-.268l5.777-.083a4.291,4.291,0,0,0,3.445-6.761l-3.327-4.727a.669.669,0,0,1-.092-.58l1.7-5.523a4.291,4.291,0,0,0-5.364-5.366Zm1.069,3.461a.67.67,0,0,1,.835.837l-1.7,5.52a4.285,4.285,0,0,0,.592,3.736l3.326,4.722a.668.668,0,0,1-.538,1.052L115,47.064a4.287,4.287,0,0,0-3.37,1.719l-3.464,4.624A.669.669,0,0,1,107,53.222l-1.864-5.469a4.292,4.292,0,0,0-2.675-2.675l-5.473-1.866a.669.669,0,0,1-.185-1.168l4.625-3.464a4.292,4.292,0,0,0,1.716-3.37l.083-5.777a.663.663,0,0,1,1.052-.536L109,32.223a4.293,4.293,0,0,0,3.736.59Z",
    transform: "translate(-15.868 -4.296)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108654",
    "data-name": "Trazado 108654",
    d: "M7.5,33.018l1.7,5.52a.669.669,0,0,1-.092.58L5.785,43.845A4.29,4.29,0,0,0,9.231,50.6l5.777.083a.663.663,0,0,1,.525.268L19,55.579a4.288,4.288,0,0,0,7.492-1.187l1.867-5.473a.668.668,0,0,1,.415-.415l5.473-1.866a4.291,4.291,0,0,0,1.187-7.494l-4.624-3.464a.669.669,0,0,1-.268-.525l-.083-5.779A4.291,4.291,0,0,0,23.7,25.933L18.971,29.26a.663.663,0,0,1-.58.092l-5.527-1.7A4.293,4.293,0,0,0,7.5,33.018m3.461-1.069a.668.668,0,0,1,.835-.837l5.522,1.7a4.293,4.293,0,0,0,3.736-.59L25.781,28.9a.663.663,0,0,1,1.052.536l.083,5.777a4.292,4.292,0,0,0,1.716,3.37l4.625,3.464a.669.669,0,0,1-.185,1.168L27.6,45.08a4.294,4.294,0,0,0-2.671,2.672l-1.866,5.473a.669.669,0,0,1-1.168.185L18.43,48.786a4.287,4.287,0,0,0-3.37-1.719l-5.777-.083a.663.663,0,0,1-.537-1.056L12.073,41.2a4.284,4.284,0,0,0,.589-3.736Z",
    transform: "translate(-0.854 -4.295)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108655",
    "data-name": "Trazado 108655",
    d: "M61.377,47.867a33.8,33.8,0,1,0,33.8,33.8,33.8,33.8,0,0,0-33.8-33.8m0,3.622A30.184,30.184,0,1,1,31.194,81.673,30.184,30.184,0,0,1,61.377,51.489",
    transform: "translate(-4.709 -8.175)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108656",
    "data-name": "Trazado 108656",
    d: "M77.569,92.237c-6.728,0-19.316,0-26.043.047a5.391,5.391,0,0,0-4.97,7.436,19.451,19.451,0,0,0,36.036.02,5.434,5.434,0,0,0-5.026-7.5Zm0,3.622a1.812,1.812,0,0,1,1.675,2.5,15.828,15.828,0,0,1-29.333-.006l-.006-.011a1.766,1.766,0,0,1,1.626-2.438h.012c6.717-.047,19.3-.047,26.019-.047Z",
    transform: "translate(-7.882 -15.752)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108657",
    "data-name": "Trazado 108657",
    d: "M48.771,79.157a2.789,2.789,0,0,1,1.358-1.736,5.135,5.135,0,0,1,1.289-.574,5.291,5.291,0,0,1,2.065-.276,5.258,5.258,0,0,1,1.728.172,5.71,5.71,0,0,1,1.123.382,3.014,3.014,0,0,1,1.859,2.032.912.912,0,1,0,1.824,0v0a5.127,5.127,0,0,0-1.981-4.478,7.241,7.241,0,0,0-3.068-1.552,7.122,7.122,0,0,0-1.493-.177,7.51,7.51,0,0,0-1.97.3,7.027,7.027,0,0,0-2.6,1.41,5.124,5.124,0,0,0-1.969,4.5.912.912,0,0,0,1.824,0Z",
    transform: "translate(-8.013 -12.458)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108658",
    "data-name": "Trazado 108658",
    d: "M75.777,79.157a2.789,2.789,0,0,1,1.36-1.736,5.149,5.149,0,0,1,1.294-.575,8.244,8.244,0,0,1,3.79-.1,5.656,5.656,0,0,1,1.123.382A3.012,3.012,0,0,1,85.2,79.159a.912.912,0,0,0,1.824,0,5.125,5.125,0,0,0-1.981-4.478,7.241,7.241,0,0,0-3.068-1.552,7.122,7.122,0,0,0-1.493-.177,7.51,7.51,0,0,0-1.97.3,7.027,7.027,0,0,0-2.6,1.41,5.128,5.128,0,0,0-1.967,4.5.912.912,0,0,0,1.824,0",
    transform: "translate(-12.626 -12.458)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_108659",
    "data-name": "Trazado 108659",
    d: "M54.762,108.059a1.81,1.81,0,0,0,.7,2.193,19.414,19.414,0,0,0,21.081.006,1.81,1.81,0,0,0,.7-2.195c-1.61-4.02-6.009-6.99-11.238-6.99s-9.624,2.969-11.235,6.987Zm4.113-.012a9.243,9.243,0,0,1,14.248,0,15.808,15.808,0,0,1-14.247,0Z",
    transform: "translate(-9.33 -17.261)",
    fill: "#3b0310",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86421",
    "data-name": "Rect\\xE1ngulo 86421",
    width: 113.34,
    height: 111.449,
    transform: "translate(0)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTresEstrellas);
export default __webpack_public_path__ + "static/media/tres_estrellas.03c7321eb206820cad89c2ebc4d5ea4f.svg";
export { ForwardRef as ReactComponent };